import React, { useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const AddEducationAchievement = ({
  getUserCv,
  userDataId,
  handleCloseEducationAhievement,
  showEducationAchievement,
  educationData,
}) => {
  console.log("educationData", educationData);
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams(); 
  const [achivement, setAchivement] = useState("");
  const [achivementDate, setAchivementDate] = useState("");
  const [display, setDisplay] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      eduId: educationData.usrDataEductnId,
    //   id: 0,
      achievement: achivement,
      achievementDate: moment(achivementDate).format("YYYY-MM-DD"),
    };
    console.log("body====>", body);
    if (achivement === "" || achivementDate === "") {
      toast.error("Please fill all the required fields");
    } else {
      try {
        const res = await axios.post("/Resume/AddEducationAchievement", body);
        toast.success(res.data.message);
        handleCloseEducationAhievement();
        getUserCv();
        setAchivement("");
        setAchivementDate("");
        setDisplay(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    }
  };
  return (
    <Modal
      show={showEducationAchievement}
      onHide={handleCloseEducationAhievement}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Add Education Achivement</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseEducationAhievement}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12}>
            <Form.Group controlId="grade">
              <Form.Label className="class-type">
                Achivement{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
              <Form.Control
                type="text"
                value={achivement}
                onChange={(e) => setAchivement(e.target.value)}
                placeholder="Enter Achivement"
                className="Dark-Input-from-group"
              />
              {display && !achivement ? (
                <span className="error_msg_lbl">Add Achievement </span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Group controlId="endYear">
              <Form.Label className="class-type">
                Achivement Date{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
              <Flatpickr
                type="number"
                value={achivementDate}
                onChange={(date) => setAchivementDate(date[0])}
                placeholder="Enter Achivement Date"
                className="Dark-Input-from-group"
                // disabled={isPresent}
              />
              {display && !achivementDate ? (
                <span className="error_msg_lbl">Select Achievement Date </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" onClick={handleSubmit}>
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddEducationAchievement;
